export default __webpack_public_path__ + "static/media/failed-not-selected.9293c2ff.svg";